export enum RenderedForm {
  EXPEDIENT_INSURER = 'expedientInsurer',
  EXPEDIENT_INSURER_FORM = 'expedientInsurerForm',
  CUSTOMER_DETAIL_FORM = 'customerInvoicesDetailsForm',
  PROFORMA_DETAIL_FORM = 'proformaInvoicesDetailsForm',
  PROVIDER_DETAIL_FORM = 'providerInvoicesDetailsForm'
}
